/*
 * jBone.widget.pagination
 */

define(function(require, exports, module) {
    'use strict';
    var $ = require('j'),
        _ = require('underscore'),
        tmpl = require('tmpl');

    require('common/jbone.widget');

    module.exports = $.widget('pagination', {

        /**
         * Options by default
         * @type {Object}
         */
        options: {

            /**
             * Total pages count
             * @type {Number}
             */
            pagesCount: 1,

            /**
             * The current page that will be seleced after loading
             * @type {Number}
             */
            startPage: 1,

            /**
             * Max visible pages per moment
             * @type {Number}
             */
            maxVisiblePages: 5,

            /**
             * Go to first page link text. If null then link will be hidden
             * @type {String}
             */
            firstLabel: 'First',

            /**
             * Go to previous page link text. If null then link will be hidden
             * @type {String}
             */
            prevLabel: 'Previous',

            /**
             * Go to next link text. If null then link will be hidden
             * @type {String}
             */
            nextLabel: 'Next',

            /**
             * Go to last page link text. If null then link will be hidden
             * @type {String}
             */
            lastLabel: 'Last',

            onPageChange: function() {}
        },

        init: function(options) {
            _.extend(this.options, options);

            this.currentPage = this.options.startPage;

            this.on(this.$el, {
                'tap .fn-goto-page': this._gotoPage
            }, this);

            this.setPagesCount(this.options.pagesCount);
        },

        /**
         * @param {Number} pagesCount
         */
        setPagesCount: function(pagesCount) {
            this.pagesCount = pagesCount;
            this.maxVisiblePages = Math.min(this.options.maxVisiblePages, this.pagesCount);

            this.render();
        },

        render: function() {
            this.$el.html(tmpl['pagination.widget.nav'](_.extend({
                currentPage: this.currentPage,
                pages: this.getPages()
            }, this.options)));

            return this;
        },

        destroy: function() {
            this.off(this.$el, 'tap .fn-goto-page', this._gotoPage);

            $.Widget.prototype.destroy.call(this);
        },

        /**
         * Returns visible pages
         * @returns {Array<Number>}
         */
        getPages: function() {
            var half = Math.floor(this.maxVisiblePages / 2);
            var start = this.currentPage - half + 1 - this.maxVisiblePages % 2;
            var end = this.currentPage + half;

            // handle boundary case
            if (start <= 0) {
                start = 1;
                end = this.maxVisiblePages;
            }
            if (end > this.pagesCount) {
                start = this.pagesCount - this.maxVisiblePages + 1;
                end = this.pagesCount;
            }

            return _.range(start, end + 1);
        },

        /**
         * @param {Number} page
         */
        openPage: function(page) {
            if (page !== this.currentPage) {
                this.currentPage = page;
                this.render();
                this.options.onPageChange(page);
            }
        },

        /**
         * @private
         */
        _gotoPage: function(event) {
            var page = event.target.dataset.page,
                pages = {
                    first: 1,
                    last: this.pagesCount,
                    next: Math.min(this.currentPage + 1, this.pagesCount),
                    prev: Math.max(this.currentPage - 1, 1)
                };

            this.openPage(pages[page] || Number(page));
        }
    });
});